<template>
  <aeria-main></aeria-main>
</template>
